import React, { useState } from "react";
import { X } from "lucide-react";

/**
 * Blue info strip — dismiss with X (hidden until user leaves the page / remount).
 * @param {string} bannerKey — stable id so remounting the page shows the banner again
 */
export default function CompanyFormsInfoBanner({
  bannerKey,
  icon: Icon,
  children,
  className = "",
}) {
  const [visible, setVisible] = useState(true);

  if (!visible) {
    return null;
  }

  return (
    <div
      role="status"
      className={`company-forms-info-banner mb-3 flex items-start gap-2 rounded-lg border border-[#DBEAFE] bg-[#F0F7FF] px-3 py-2 text-[12px] text-[#475569] ${className}`.trim()}
      data-banner-key={bannerKey}
    >
      {Icon ? (
        <Icon
          className="company-forms-info-banner__icon mt-0.5 shrink-0 text-[#007BFF]"
          size={15}
          strokeWidth={1.75}
          aria-hidden
        />
      ) : null}
      <div className="company-forms-info-banner__body min-w-0 flex-1 leading-relaxed">
        {children}
      </div>
      <button
        type="button"
        className="company-forms-info-banner__close inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-[#64748B] transition hover:bg-[#DBEAFE]/80 hover:text-[#14213D]"
        onClick={() => setVisible(false)}
        aria-label="Dismiss message"
      >
        <X size={14} strokeWidth={2} aria-hidden />
      </button>
    </div>
  );
}
